import React from 'react';
import AwardNoticeDetails from './AwardNoticeDetails';

/**
 * NoticeDetailsRouter - Componentă unificată pentru toate tipurile de anunțuri de atribuire
 * Suportă: CAN, RFQA, SCNA, PCA, RDC, RFDA
 */
const NoticeDetailsRouter = () => {
  // Componenta AwardNoticeDetails este acum unificată și gestionează toate tipurile
  return <AwardNoticeDetails />;
};

export default NoticeDetailsRouter;
